// src/components/BlockList.js
import React, { useContext, useEffect } from 'react';
import { NavLink, Outlet, useParams, useNavigate } from 'react-router-dom';
import { StudentContext } from '../StudentContext';
import './BlockList.css';

const BlockList = () => {
  const { blockId } = useParams();
  const navigate = useNavigate();
  const { blocks, allBlocks, isLoading } = useContext(StudentContext);

  const visibleBlockIds = Object.keys(blocks || {});
  const allBlockIds = Object.keys(allBlocks || {});

  // Tự động chuyển đến Khối khả dụng đầu tiên nếu chưa chọn Khối nào trên URL
  useEffect(() => {
    if (!isLoading && !blockId && visibleBlockIds.length > 0) {
      navigate(`/main/class-list/${visibleBlockIds[0]}`, { replace: true });
    }
  }, [isLoading, blockId, visibleBlockIds, navigate]);

  if (isLoading) {
    return <div className="loading-message">⏳ Đang tải danh sách Khối/Ngành...</div>;
  }

  if (allBlockIds.length === 0) {
    return <div className="no-data-message">Chưa có danh mục Khối/Ngành trong niên khóa hiện tại.</div>;
  }

  // Tên hiển thị khối
  const getDisplayName = (key) => {
    const classes = allBlocks[key];
    if (classes && classes.length > 0) {
      const sample = classes[0].name || '';
      if (sample.includes('Chiên Con') || sample.includes('Tô Màu')) return 'Chiên Con';
      if (sample.includes('Ấu') || sample.includes('Khai Tâm')) return 'Ngành Ấu';
      if (sample.includes('Thiếu') || sample.includes('Thêm Sức')) return 'Ngành Thiếu';
      if (sample.includes('Nghĩa') || sample.includes('Bao Đồng')) return 'Ngành Nghĩa';
      if (sample.includes('Vào Đời') || sample.includes('Dự Bị')) return 'Ngành Hiệp Sĩ';
    }
    return key.toUpperCase();
  };

  return (
    <div className="block-list-container">
      <div className="block-nav">
        {allBlockIds.map((bId) => {
          const isAccessible = visibleBlockIds.includes(bId);
          return (
            <NavLink
              key={bId}
              to={`/main/class-list/${bId}`}
              className={({ isActive }) =>
                isActive && isAccessible ? 'active' : isAccessible ? '' : 'disabled'
              }
            >
              {getDisplayName(bId)}
            </NavLink>
          );
        })}
      </div>
      <div className="block-content">
        <Outlet />
      </div>
    </div>
  );
};

export default BlockList;